import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import FormInput from "Root/profile/components/common/FormInput";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import TopRightX from "Root/profile/components/common/TopRightX/TopRightX";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import toastService from "Root/profile/toastService";
import { apiUpdateUserPassword } from "Root/api/apiProfile";
import { validatePassword } from "../../utils";
import styles from "./styles.module.css";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
const ChangePasswordBox = ({ closeBox }) => {
    const [passwordObj, setPasswordObj] = useState({
        old_password: "",
        new_password: "",
        new_password_confirm: "",
    });
    // const { setGlobalLoading } = useContext(GeneralContext);
    const dispatch = useDispatch();
    const isMobile = useScreenWidth() < 768;
    const onPasswordChange = (value, name) => {
        setPasswordObj({
            ...passwordObj,
            [name]: value,
        });
    };
    const updatePassword = async () => {
        try {
            // //setGlobalLoading(true);
            dispatch(setGlobalLoading(true));
            await apiUpdateUserPassword(passwordObj);
            toastService.successMessage("Your password was updated");
            closeBox();
        }
        catch (e) {
            const { message } = e;
            if (message) {
                toastService.errorMessage(message);
            }
            else {
                toastService.errorMessage("Something went wrong");
            }
        }
        finally {
            // setGlobalLoading(false);
            dispatch(setGlobalLoading(false));
        }
    };
    const passwordError = validatePassword(passwordObj);
    return (_jsxs("div", { className: styles.change_password, children: [_jsxs("div", { className: styles.change_password_title, children: [_jsx("h3", { className: "my-profile__chapter-title", children: "Change Password" }), _jsx(TopRightX, { onClick: () => closeBox() })] }), _jsx(FormInput, { className: styles.password_input, type: "password", onChange: onPasswordChange, value: passwordObj.old_password, label: "Old Password", name: "old_password" }), _jsx(FormInput, { className: styles.password_input, type: "password", onChange: onPasswordChange, value: passwordObj.new_password, label: "New Password", name: "new_password" }), _jsx(FormInput, { className: styles.password_input, type: "password", onChange: onPasswordChange, value: passwordObj.new_password_confirm, label: "Confirm Password", name: "new_password_confirm" }), passwordError && _jsx("span", { className: styles.error_message, children: passwordError }), _jsx(RoundedGainfulButton, { extraClassName: `${styles.update_password} ${passwordError ? styles.disable_button : ""}`, label: "Update Password", onClick: updatePassword })] }));
};
export default ChangePasswordBox;
